document.querySelectorAll('.ns-family-header').forEach((header) => {
  const toggle = header.querySelector('.ns-family-toggle');
  const nav = header.querySelector('.ns-family-nav');
  if (!toggle || !nav) return;
  const close = () => { nav.classList.remove('open'); toggle.setAttribute('aria-expanded', 'false'); };
  toggle.addEventListener('click', () => { const open = nav.classList.toggle('open'); toggle.setAttribute('aria-expanded', String(open)); });
  nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));
  header.addEventListener('keydown', (event) => { if (event.key === 'Escape') { close(); toggle.focus(); } });
  document.addEventListener('click', (event) => { if (!header.contains(event.target)) close(); });
  window.matchMedia('(min-width:1200px)').addEventListener('change', close);
});
